import { render, staticRenderFns } from "./Proximos.vue?vue&type=template&id=0c32f428"
import script from "./Proximos.vue?vue&type=script&lang=js"
export * from "./Proximos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports